import mixin from './mixin.js';
const defaultApp = {
    mixins: [mixin],
    data() {
        return {
            dataApi: '',
            dataLimit: 10,
            dataSortKey: '',
            dataSortDirection: '',
            dataWidget: false,
            dataOverruleIds: [],
            loading: false,
            loadMore: false,
            data: {
                items: [],
                facets: []
            },
            searchText: ''
        }
    },
    computed: {
        facetsSet() {
            return this.data && this.data.facets && this.data.facets.length;
        },
        itemsSet() {
            return this.data && this.data.items && this.data.items.length;
        },
        filtersChosen() {
            return (this.facetsSet && this.data.facets.some(facet => facet.values.length)) || this.dataOverruleIds.length || this.dataLocation !== '' || (this.filterField !== '' && this.filterValue.length);
        },
        filtersActive() {
            return this.facetsSet && (this.data.facets.some(facet => facet.selected) || this.searchText);
        },
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        queryModel() {
            return {
                Limit: this.dataLimit,
                Offset: this.data.items.length ? (this.page - 1) * this.dataLimit : 0,
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
                Text: this.searchText
            }
        },
    },
    methods: {
        async fetchInitialData() {
            this.page = 1;
            this.data.items = [];
            this.loading = true;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
            this.loading = false;
        },
        async loadmore() {
            this.loadMore = true;
            this.page++;
            const response = await this.fetchData();
            this.setData(response);
            this.updateUrl();
            this.loadMore = false;
        },
        removeDuplicatesById(array) {
            return array.reduce((accumulator, current) => {
                if (!accumulator.find((item) => item.id === current.id)) {
                    accumulator.push(current);
                }
                return accumulator;
            }, []);
        },
        toggleOption(facetAlias, optionAlias, fetch = true) {
            let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
            if (changedFacet.values.includes(optionAlias)) {
                changedFacet.values = changedFacet.values.filter(value => value !== optionAlias);
            } else {
                changedFacet.values.push(optionAlias);
            }
            if (fetch) {
                this.fetchInitialData();
            }
        },
        selectOption(facetAlias, event) {
            let optionAlias = event.target.value;
            let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
            if (optionAlias === '') {
                changedFacet.values = [];
            } else {
                changedFacet.values = [optionAlias];
            }
            this.fetchInitialData();
        },
        removeSelect(facetAlias) {
            let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
            changedFacet.values = [];
            this.page = 1;
            this.fetchInitialData();
        },
        updateUrl() {
            if (!this.queryModel.Text && !this.queryModel.FilterItems.length && this.page === 1) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.Text) urlParams.set('text', this.queryModel.Text);
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => urlParams.set(filterItem.Key, filterItem.Values.join()))
            }
            if (this.page > 1) urlParams.set('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
    }
}

export default defaultApp;